import _jsx from "@babel/runtime/helpers/jsx";
var _Alert;
import PropTypes from 'prop-types';
import React, { useContext, useCallback } from 'react';
import clsx from 'clsx';
import { Alert, Box, SideBarToModal, Text } from 'reaxl';
import EmailContext from '../EmailContext';
import EmailFormTitle from '../EmailFormTitle';
import EmailForm from '../EmailForm';
import EmailStaticContent from '../EmailStaticContent';
/**
 *  EmailSideBarToModal renders email CTA SideBarToModal and email confirmation
 *
 */
const EmailSideBarToModal = /*#__PURE__*/React.memo(_ref => {
  let {
    ctaProps = {},
    isConfirmation,
    isEditEmailModal = false,
    isSm,
    isXs,
    setServerError,
    showConfirmation,
    toggleAlert,
    selectedListings = [],
    setSelectedListings = () => {},
    additionalInventoryInfo = {},
    setAdditionalInventoryInfo = () => {},
    isButtonDisabled,
    additionalContent,
    title = '',
    footerContent,
    setOneClickChecked,
    setShowEmailConfirmation,
    nextSteps,
    ...rest
  } = _ref;
  const {
    uiContext
  } = useContext(EmailContext);
  let showModal = ctaProps.show;
  if (isConfirmation) {
    showModal = showConfirmation;
  }
  const handleOnHide = useCallback(() => {
    const validContextList = ['calculator', 'calculatorBreakdownConfirmation', 'calculatorOfferSummary', 'creditStatus', 'cta', 'edit', 'multi', 'quote', 'split', 'vehicleHistoryReport'];
    if (toggleAlert && setServerError) {
      toggleAlert(false);
      setServerError(null);
    }
    if (isConfirmation) {
      setShowEmailConfirmation(false);
    }
    if (typeof ctaProps.onHide === 'function' && validContextList.includes(uiContext)) {
      ctaProps.onHide();
    }
    if (setSelectedListings) {
      setSelectedListings([]);
    }
    setAdditionalInventoryInfo({});
  }, [toggleAlert, setServerError, isConfirmation, uiContext, setShowEmailConfirmation, ctaProps, setSelectedListings, setAdditionalInventoryInfo]);
  const renderEmailForm = /*#__PURE__*/React.createElement(EmailForm, Object.assign({
    ctaContext: ctaProps.context,
    isConfirmation: isConfirmation,
    isEditEmailModal: isEditEmailModal,
    isButtonDisabled: additionalInventoryInfo?.listings?.length && !selectedListings.length || isButtonDisabled,
    additionalInventoryInfo: additionalInventoryInfo,
    setOneClickChecked: setOneClickChecked,
    nextSteps: nextSteps
  }, rest));
  const renderEmailFormContent = ['calculatorOfferSummary', 'calculatorBreakdownConfirmation', 'split'].includes(uiContext) && !!additionalContent ? /*#__PURE__*/React.createElement(React.Fragment, null, uiContext === 'calculatorBreakdownConfirmation' && nextSteps && (_Alert || (_Alert = /*#__PURE__*/_jsx(Alert, {
    "data-cmp": "emailConfirmation",
    bsStyle: "success",
    className: "margin-top-2"
  }, void 0, /*#__PURE__*/_jsx(Text, {
    weight: "bold"
  }, void 0, "Success!"), "\xA0 Your offer has been sent."))), /*#__PURE__*/_jsx("div", {
    className: "row"
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: clsx('col-xs-12', 'margin-bottom-4', {
      'col-md-6 col-sm-12': uiContext !== 'split',
      'col-sm-12 col-md-7': uiContext === 'split'
    })
  }, void 0, additionalContent), /*#__PURE__*/_jsx("div", {
    className: clsx('col-xs-12', {
      'col-md-6 col-sm-12': uiContext !== 'split',
      'col-sm-12 col-md-5': uiContext === 'split'
    })
  }, void 0, uiContext === 'calculatorBreakdownConfirmation' && nextSteps && /*#__PURE__*/_jsx(Box, {
    backgroundColor: "transparent",
    borderColor: "neutral-secondary"
  }, void 0, nextSteps), uiContext !== 'calculatorBreakdownConfirmation' && renderEmailForm))) : renderEmailForm;
  return /*#__PURE__*/_jsx(SideBarToModal, {
    title: title || /*#__PURE__*/_jsx(EmailFormTitle, {
      isConfirmation: isConfirmation,
      isEditEmailModal: isEditEmailModal
    }),
    content: renderEmailFormContent,
    collapsed: isXs,
    show: showModal,
    onHide: handleOnHide,
    sideBarOptions: {
      fullWidth: true,
      ...(uiContext === 'split' && isXs && {
        action: footerContent
      })
    },
    modalOptions: {
      bsSize: ['calculator', 'calculatorOfferSummary', 'calculatorBreakdownConfirmation', 'split'].includes(uiContext) && !isConfirmation && !isSm || isSm && uiContext === 'split' ? 'large' : 'small',
      scrollPanel: false
    },
    footerContent: footerContent
  });
});
export default EmailSideBarToModal;